import React from 'react';
import './Venue.css';

import { venue } from '../../../constants';
import { Heading, Lightbox, PageTitle, VenueDetails } from '../../../components';
import { Gallery } from '../../../sections';
import { PhotoProvider, PhotoView } from 'react-photo-view';
import { FaPlus } from 'react-icons/fa';


const Venue = () => {

  return (

    <>

      {/* Page Title */}
      <PageTitle title={'Venue'} page={'Venue'} />

      <section className="venue">

        {/* Venue Details Section */}
        <VenueDetails />

        {/* ========== Venue Features ========== */}
        <div className="venue-features">
          {venue.venueFeatures.map((feature, index) => (
            <div key={index} className="venue-feature">
              <div className='icon'>{feature.icon}</div> {/* Feature Icon */}
              <h3>{feature.title}</h3> {/* Feature Title */}
              <p>{feature.desc}</p> {/* Feature Description */}
            </div>
          ))}
        </div>

        {/* ========== Hotel Rooms ========== */}
        <section className='venue-gallery'>
    
          {/* Image Grid Container */}
          <div className='box-container'>
            {/* PhotoProvider to handle image preview */}
            <PhotoProvider>
              {venue.venueGallery.map((image, index) => (
    
                  <div className={`venue-gallery-item gallery-${index + 1}`} key={index}>
    
                    {/* Display Image */}
                    <img src={image} alt={`gallery-${index + 1}`} /> 
    
                    {/* Image Hover Effect with Icon */}
                    <div className='content'>
                      <PhotoView key={index} src={image}>
                        <div className='icon'><FaPlus /></div>
                      </PhotoView>
                    </div>
    
                  </div>
      
              ))}
            </PhotoProvider>
          </div>
        </section>

      </section>

    </>

  );
};

export default Venue;